import { createContext, useContext, useMemo } from 'react'

interface IPropostaContextValue {
  idExternoBlocoPath: string
  vendedorAlocadoIdPath: string
  dataMarcacaoAlvenariaPath: string
}

interface IPropostaProviderProps {
  children: React.ReactNode
  idExternoBlocoPath?: string
  vendedorAlocadoIdPath?: string
  dataMarcacaoAlvenariaPath?: string
}

const PropostaContext = createContext<IPropostaContextValue | undefined>(undefined)

export const usePropostaContext = () => {
  const context = useContext(PropostaContext)

  if (!context) {
    throw new Error('usePropostaContext deve ser usado dentro de PropostaProvider')
  }

  return context
}

export const PropostaProvider = ({
  children,
  idExternoBlocoPath,
  vendedorAlocadoIdPath,
  dataMarcacaoAlvenariaPath,
}: IPropostaProviderProps) => {
  const value = useMemo(
    () => ({
      idExternoBlocoPath: idExternoBlocoPath ?? '',
      vendedorAlocadoIdPath: vendedorAlocadoIdPath ?? '',
      dataMarcacaoAlvenariaPath: dataMarcacaoAlvenariaPath ?? '',
    }),
    [idExternoBlocoPath, vendedorAlocadoIdPath, dataMarcacaoAlvenariaPath],
  )
  return <PropostaContext.Provider value={value}>{children}</PropostaContext.Provider>
}
